import { lazy } from "react";
import Loadable from "src/routes/Loadable";

const UserProfile = Loadable(
  lazy(() => import("src/pages/dashboard/UserProfile"))
);

const Profile = Loadable(
  lazy(() => import("src/sections/@dashboard/user/profile/Profile"))
);

const EditProfile = Loadable(
  lazy(() => import("src/sections/@dashboard/user/profile/EditInfo"))
);

const ProfileSettings = Loadable(
  lazy(() =>
    import("src/sections/@dashboard/user/profile/ProfileAccountSettings")
  )
);

const ProfileReferrals = Loadable(
  lazy(() => import("src/pages/userSide/profile/subPages/referrals/index"))
);
const ProfileNotes = Loadable(
  lazy(() => import("src/sections/@dashboard/user/profile/ProfileNotes"))
);

const UserAccount = Loadable(
  lazy(() => import("src/pages/dashboard/UserAccount"))
);

const user = [
  {
    path: "profile",
    element: <UserProfile />,
    children: [
      {
        element: <Profile />,
        index: true,
      },
      {
        path: "edit",
        element: <EditProfile />,
      },
      { path: "settings", element: <ProfileSettings /> },
      { path: "referrals", element: <ProfileReferrals /> },
      { path: "notes", element: <ProfileNotes /> },
    ],
  },
  { path: "account", element: <UserAccount /> },
];

export default user;
